import { render, staticRenderFns } from "./RoutenView.vue?vue&type=template&id=61d41538&scoped=true"
import script from "./RoutenView.vue?vue&type=script&lang=js"
export * from "./RoutenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d41538",
  null
  
)

export default component.exports